import { c as _c } from "react/compiler-runtime";
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
export const useChangeItemDraft = () => {
  const $ = _c(2);
  const {
    storeId
  } = useStoreQuery();
  const {
    mutate
  } = useStore(storeId);
  let t0;
  if ($[0] !== mutate) {
    const onChangeItemDraft = async t1 => {
      const {
        callback,
        itemId,
        draft
      } = t1;
      await callback();
      await mutate(data => data && {
        ...data,
        items: data.items.map(item => {
          if (item.itemId === itemId) {
            item.draft = draft;
          }
          return item;
        })
      }, false);
    };
    t0 = {
      onChangeItemDraft
    };
    $[0] = mutate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};